import { Box, Pagination, SxProps, Typography } from "@outschool/backpack";
import { Loading } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React, { useRef, useState } from "react";

import {
  ClassroomPostFilter,
  ClassroomPostsProvider,
  useClassroomPostsContext,
} from "../../../providers/ClassroomPostsProvider";
import LearnerClassPostList from "../ClassPostList";

interface ClassroomAnnouncementsProps {
  sx?: SxProps;
  titleRef?: React.RefObject<HTMLSpanElement>;
}
export const ClassroomAnnouncements = ({
  sx,
  titleRef,
}: ClassroomAnnouncementsProps) => (
  <ClassroomPostsProvider postsFilter={ClassroomPostFilter.Announcements}>
    <AnnouncementContent sx={sx} titleRef={titleRef} />
  </ClassroomPostsProvider>
);

interface AnnouncementContentProps {
  sx?: SxProps;
  titleRef?: React.RefObject<HTMLSpanElement>;
}
const AnnouncementContent = ({ sx, titleRef }: AnnouncementContentProps) => {
  const { loading, posts, pageOptions, setTimeBounds } =
    useClassroomPostsContext();
  const [currentPage, setCurrentPage] = useState(1);
  const topOfAnnouncementsRef = useRef<HTMLDivElement>(null);

  if (!loading && (!posts || posts.length === 0)) {
    return null;
  }

  return (
    <Box
      sx={[
        { display: "flex", flexDirection: "column", gap: 16 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box ref={topOfAnnouncementsRef} />
      <Typography variant="h3" ref={titleRef}>
        Announcements
      </Typography>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
          }}
        >
          <Loading />
        </Box>
      ) : (
        <LearnerClassPostList />
      )}
      {pageOptions && pageOptions.length > 1 && (
        <Pagination
          count={pageOptions.length}
          page={currentPage}
          onChange={(_, page) => {
            setCurrentPage(page);
            setTimeBounds(pageOptions[page - 1].value);
            if (topOfAnnouncementsRef.current) {
              setTimeout(
                () =>
                  window.scrollTo({
                    behavior: "smooth",
                    top: topOfAnnouncementsRef.current!.offsetTop,
                  }),
                150,
              );
            }
          }}
          showFirstButton
          showLastButton
          customLabels={pageOptions.map(option => option.label)}
        />
      )}
    </Box>
  );
};
